import API from "../../../../global/api";

//post
export const postData = (data) => {
  return (dispatch) => {
    API.post(`fl_342_a/start-fl-432a`, data).then((res) => {
      dispatch(successPostData(data));
    })
  }
}


export const requestPostData = () => {
  return {
    type: "REQUEST_POST_DATA",
  }
}

export const successPostData = (data) => {
  return {
    type: "SUCCESS_POST_DATA",
    payload: data,
  }
}

export const errorPostData = (data) => {
  return {
    type: "ERROR_POST_DATA",
    payload: data,
  }
}

//child Support Agreed
export const childSupportAgreed = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-stipulation`, data).then((res) => {
      dispatch(successputChildSupportAgreed(data));
    });
  };
};

export const requestputChildSupportAgreed = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_AGREED",
  };
};
export const successputChildSupportAgreed = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_AGREED",
    payload: data,
  };
};
export const errorputChildSupportAgreed = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_AGREED",
    payload: data,
  };
};

// Child Support Payable
export const childSupportPayable = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportPayable(data));
    });
  };
};

export const requestputChildSupportPayable = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_PAYABLE",
  };
};
export const successputChildSupportPayable = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_PAYABLE",
    payload: data,
  };
};
export const errorputChildSupportPayable = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_PAYABLE",
    payload: data,
  };
};


//child Support Factor pay
export const childSupportFactorPay = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`,data).then((res) => {
      dispatch(successputChildSupportFactorPay(data));
    });
  };
};

export const requestputChildSupportFactorPay = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_FACTOR_PAY",
  };
};
export const successputChildSupportFactorPay = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_FACTOR_PAY",
    payload: data,
  };
};
export const errorputChildSupportFactorPay = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_FACTOR_PAY",
    payload: data,
  };
};

//child Support Factor Revised
export const childSupportRevised = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportFactorRevised(data));
    });
  };
};

export const requestputChildSupportFactorRevised = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_FACTOR_REVISED",
  };
};
export const successputChildSupportFactorRevised = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_FACTOR_REVISED",
    payload: data,
  };
};
export const errorputChildSupportFactorRevised = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_FACTOR_REVISED",
    payload: data,
  };
};

//child Support Factor 
export const childSupportFactor = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportFactor(data));
    });
  };
};

export const requestputChildSupportFactor = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_FACTOR",
  };
};
export const successputChildSupportFactor = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_FACTOR",
    payload: data,
  };
};
export const errorputChildSupportFactor = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_FACTOR",
    payload: data,
  };
};

//child Support Property Tax
export const childSupportTax = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportFactorTax(data));
    });
  };
};

export const requestputChildSupportFactorTax = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_FACTOR_TAX",
  };
};
export const successputChildSupportFactorTax = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_FACTOR_TAX",
    payload: data,
  };
};
export const errorputChildSupportFactorTax = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_FACTOR_TAX",
    payload: data,
  };
};

//child Support Parent Pay
export const childSupportParentPay = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportParentPay(data));
    });
  };
};

export const requestputChildSupportParentPay = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_PARENT_PAY",
  };
};
export const successputChildSupportParentPay = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_PARENT_PAY",
    payload: data,
  };
};
export const errorputChildSupportParentPay = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_PARENT_PAY",
    payload: data,
  };
};

//child Support Contribution option.
export const childSupportContOption = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportContOption(data));
    });
  };
};

export const requestputChildSupportContOption = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_CONT_OPTION",
  };
};
export const successputChildSupportContOption = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_CONT_OPTION",
    payload: data,
  };
};
export const errorputChildSupportContOption = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_CONT_OPTION",
    payload: data,
  };
};

//child Support Special Circumstance.
export const childSupportSpecialCircumstance = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportSpecialCircumstance(data));
    });
  };
};

export const requestputChildSupportSpecialCircumstance = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_SPECIAL_CIRCUMSTANCE",
  };
};
export const successputChildSupportSpecialCircumstance = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_SPECIAL_CIRCUMSTANCE",
    payload: data,
  };
};
export const errorputChildSupportSpecialCircumstance = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_SPECIAL_CIRCUMSTANCE",
    payload: data,
  };
};

//child Support Time Share.
export const childSupportTimeShare = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportTimeShare(data));
    });
  };
};

export const requestputChildSupportTimeShare = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_TIME_SHARE",
  };
};
export const successputChildSupportTimeShare = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_TIME_SHARE",
    payload: data,
  };
};
export const errorputChildSupportTimeShare = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_TIME_SHARE",
    payload: data,
  };
};

//child Support Equal Custody.
export const childSupportEqualCustody = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportEqualCustody(data));
    });
  };
};

export const requestputChildSupportEqualCustody = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_EQUAL_CUSTODY",
  };
};
export const successputChildSupportEqualCustody = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_EQUAL_CUSTODY",
    payload: data,
  };
};
export const errorputChildSupportEqualCustody = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_EQUAL_CUSTODY",
    payload: data,
  };
};
//child Support Child Medical Other.
export const childSupportChildMedicalOther = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportChildMedicalOther(data));
    });
  };
};

export const requestputChildSupportChildMedicalOther = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_CHILD_MEDICAL_OTHER",
  };
};
export const successputChildSupportChildMedicalOther = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_CHILD_MEDICAL_OTHER",
    payload: data,
  };
};
export const errorputChildSupportChildMedicalOther = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_CHILD_MEDICAL_OTHER",
    payload: data,
  };
};

//child Support Other Specify.
export const childSupportOtherSpecify = (data) => {
  return (dispatch) => {
    API.put(`fl_342_a/add-factors`, data).then((res) => {
      dispatch(successputChildSupportOtherSpecify(data));
    });
  };
};

export const requestputChildSupportOtherSpecify = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_OTHER_SPECIFY",
  };
};
export const successputChildSupportOtherSpecify = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_CHILD_OTHER_SPECIFY",
    payload: data,
  };
};
export const errorputChildSupportOtherSpecify = (data) => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_CHILD_OTHER_SPECIFY",
    payload: data,
  };
};

//Get All Data.
export const childSupportGetAllData = (data) => {
  return (dispatch) => {
    API.post(`fl_342_a/get-all-data-fl-342a`, data).then((res) => {
      let data = res.data;
      dispatch(successputChildSupportGetAllData(data));
    }).catch((error)=>{
      dispatch(errorputChildSupportGetAllData());
    })
  };
};

export const requestputChildSupportGetAllData = () => {
  return {
    type: "REQUEST_FL_342_CHILD_SUPPORT_GET_ALL_DATA",
  };
};
export const successputChildSupportGetAllData = (data) => {
  return {
    type: "SUCCESS_FL_342_CHILD_SUPPORT_GET_ALL_DATA",
    payload: data,
  };
};
export const errorputChildSupportGetAllData = () => {
  return {
    type: "ERROR_FL_342_CHILD_SUPPORT_CHILD_GET_ALL_DATA",
  };
};



